<template>
	<b-modal title="Info Attivita" ref="mdlRsaAreaEsecuzioneView" id="mdlRsaAreaEsecuzioneView" size="lg" @ok="onOk" ok-only no-close-on-backdrop no-close-on-esc scrollable b-modal>
		<!-- modal-class="sa-modal-static-scroll" -->
		<div class="sa-tab-scroll">
			<!--      <div class="sa-flexbox">
                <div class="sa-flexbox-header"> -->
			<b-card class="sa-card" :header="jsonData.nomeAttivita" header-tag="header" footer-tag="footer">
				<b-card-text>
					<b-row no-gutters>
						<b-col cols="12" sm="12" md="6" lg="6" xl="6">
							<label class="sa-label-data">Data Ora Prevista:</label>
							<span>{{ formatDateTime(jsonData.dataOraPrevista) }} </span>
						</b-col>
						<b-col cols="12" sm="12" md="6" lg="6" xl="6">
							<label class="sa-label-data">Data Ora Esecuzione:</label>
							<span>{{ formatDateTime(jsonData.dataOraEsecuzione) }} </span>
						</b-col>
						<b-col cols="12" sm="12" md="6" lg="6" xl="6">
							<label class="sa-label-data">Stato:</label>
							<span>{{ jsonData.stato }}</span>
						</b-col>
						<b-col cols="12" sm="12" md="6" lg="6" xl="6">
							<label class="sa-label-data">Operatore</label>
							<span>{{ jsonData.operatore }}</span>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
							<label class="sa-label-data">Indicazioni:</label>
							<span v-html="jsonData.indicazioni"></span>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
							<label class="sa-label-data">Note:</label>
							<span v-html="jsonData.note"></span>
						</b-col>
					</b-row>
				</b-card-text>
			</b-card>
			<template v-if="jsonData.idForm">
				<b-row style="margin-top: 10px">
					<b-col cols="12">
						<dynamic-form ref="cmpDynamicForm" :jsonData="jsonForm"></dynamic-form>
					</b-col>
				</b-row>
			</template>
		</div>
	</b-modal>
</template>

<script>
import DynamicForm from "../../../utility/components/DynamicForm.vue";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
	components: { DynamicForm },
	mixins: [UtilityMixin],
	data() {
		return {
			jsonForm: { titolo: "", jsonForm: [] },
			pathResource: "/rsaattivitapazienti/slot",
			pathResourceDynamicForm: "/dynamicform",
			pathResourceDynamicFormData: null,
			jsonData: { stato: null },
			statiOptions: [
				{ value: null, text: "-Seleziona Stato-" },
				{ value: "ESEGUITA", text: "ESEGUITA" },
				{ value: "NON ESEGUITA", text: "NON ESEGUITA" },
			],
		};
	},
	methods: {
		add(data) {
			let me = this;
			me.jsonData = data;
			// console.log(data);
			let form = me.jsonData.idForm;
			if (form && data.stato === "ESEGUITA") {
				me.loadSchemaForm(form);
			}
			me.$refs.mdlRsaAreaEsecuzioneView.show();
		},
		onOk() {
			let me = this;
			me.$emit("afterCloseModal");
		},

		loadSchemaForm(idForm) {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + idForm, {}, me.loadSchemaFormSuccess, me.loadSchemaFormError);
		},
		loadSchemaFormSuccess(response) {
			let me = this;
			me.pathResourceDynamicFormData = response.data.data.pathModule;
			me.jsonForm.jsonForm = JSON.parse(response.data.data.jsonForm);
			me.jsonForm.titolo = response.data.data.titolo;
			me.loadDataForm(response.data.data.id);
		},
		loadSchemaFormError(error) {
			console.log(error);
		},

		loadDataForm(idResource) {
			console.log("carico form data " + idResource);
			//UtilityMixin.methods.loadDataResources(me.pathResourceDynamicFormData + "/" + idResource, {}, me.loadDataFormSuccess, me.loadDataFormError);
		},
		loadDataFormSuccess(response) {
			//let me = this;
			console.log(response);
		},
		loadDataFormError(error) {
			console.log(error);
		},
	},
};
</script>

<style scoped>
.sa-flexbox-body .row {
	flex: 1;
	height: 1px;
}

.sa-flexbox-body .row .col-sm-12.col-md-12.col-lg-12.col-xl-12.col-12 {
	height: 100%;
}
</style>
